import { useEffect } from "react";
import { getUnauthenticatedRedirect } from "@/shared/api/session";
import { useSession } from "@/features/auth/hooks/use-session";

export function SessionGate({ children }: { children: React.ReactNode }) {
  const { status } = useSession();

  useEffect(() => {
    if (status === "unauthenticated") window.location.replace(getUnauthenticatedRedirect());
  }, [status]);

  if (status !== "authenticated") return null;
  return <>{children}</>;
}
